import * as React from "react";
import * as ReactDOM from "react-dom/client";

import CatalogList from "./Catalog/List";
import CatalogReport from "./Catalog/Report";
import CategoryList from "./Category/List";
import CategoryDocumentCreateSelectList from "./CategoryDocument/CreateSelectList";
import CategoryDocumentDeleteSelectList from "./CategoryDocument/DeleteSelectList";
import CategoryDocumentList from "./CategoryDocument/List";
import ContributorList from "./Contributor/List";
import DocContainer from "./Doc/Container";
import DocumentCaptureList from "./Document/CaptureList";
import DocumentList from "./Document/List";
import DocumentContributorList from "./DocumentContributor/List";
import DocumentSetEditDocumentsAccessTable from "./DocumentSet/EditDocumentsAccessTable";
import DocumentSetEditDocumentsActivitiesTable from "./DocumentSet/EditDocumentsActivitiesTable";
import DocumentSetList from "./DocumentSet/List";
import DocumentSetNewBatchPreset from "./DocumentSet/NewBatchPreset";
import DocumentSetReport from "./DocumentSet/Report";
import DocumentSetDocumentRelationCreateSelectList from "./DocumentSetDocumentRelation/CreateSelectList";
import DocumentSetDocumentRelationDeleteSelectList from "./DocumentSetDocumentRelation/DeleteSelectList";
import DocumentSetDocumentRelationList from "./DocumentSetDocumentRelation/List";
import DocumentSetUserPermissionCreateSelectList from "./DocumentSetUserPermission/CreateSelectList";
import DocumentSetUserPermissionSelectList from "./DocumentSetUserPermission/SelectList";
import DocumentUserList from "./DocumentUser/List";
import GroupExpirationDatePicker from "./Group/ExpirationDatePicker";
import GroupList from "./Group/List";
import GroupDocumentCreateBatchSelectList from "./GroupDocument/CreateBatchSelectList";
import GroupDocumentDeleteBatchSelectList from "./GroupDocument/DeleteBatchSelectList";
import GroupRoleDefinitionUserTable from "./GroupRoleDefinitionUser/Table";
import InstitutionList from "./Institution/List";
import InstitutionContributorList from "./InstitutionContributor/List";
import MediaAssetNewMediaRecorder from "./MediaAsset/NewMediaRecorder";
import MediaAssetNewWebkit from "./MediaAsset/NewWebkit";
import UserList from "./User/List";
import VersionList from "./Version/List";

const components: Record<string, React.ElementType> = {
  CatalogList,
  CatalogReport,
  CategoryList,
  CategoryDocumentCreateSelectList,
  CategoryDocumentDeleteSelectList,
  CategoryDocumentList,
  ContributorList,
  DocContainer,
  DocumentCaptureList,
  DocumentList,
  DocumentContributorList,
  DocumentSetEditDocumentsAccessTable,
  DocumentSetEditDocumentsActivitiesTable,
  DocumentSetList,
  DocumentSetNewBatchPreset,
  DocumentSetReport,
  DocumentSetDocumentRelationCreateSelectList,
  DocumentSetDocumentRelationDeleteSelectList,
  DocumentSetDocumentRelationList,
  DocumentSetUserPermissionCreateSelectList,
  DocumentSetUserPermissionSelectList,
  DocumentUserList,
  GroupExpirationDatePicker,
  GroupList,
  GroupDocumentCreateBatchSelectList,
  GroupDocumentDeleteBatchSelectList,
  GroupRoleDefinitionUserTable,
  InstitutionList,
  InstitutionContributorList,
  MediaAssetNewMediaRecorder,
  MediaAssetNewWebkit,
  UserList,
  VersionList,
};

export default function mount(): void {
  const mountPoints = document.querySelectorAll("[data-react-component]");
  mountPoints.forEach((mountPoint) => {
    const { dataset } = mountPoint as HTMLElement;
    const componentName = dataset.reactComponent;
    if (componentName) {
      const Component = components[componentName];
      if (Component) {
        const props = JSON.parse(dataset.reactProps as string);
        const root = ReactDOM.createRoot(mountPoint);
        root.render(<Component {...props} />);

        document.addEventListener("turbo:before-render", () => {
          if (root) { root.unmount(); }
        }, { once: true });
      } else {
        console.warn(
          "WARNING: No component found for: ",
          dataset.reactComponent,
          components,
        );
      }
    }
  });
}

// document.addEventListener("DOMContentLoaded", mount);
document.addEventListener("turbo:load", mount);

